// client/src/routes/app/utilities/index.tsx — SCR-UTIL-001 · MAINT-008 (04 §8.8).
//
// Replaces UI-003's `PlaceholderScreen`, which named this item as its owner.
//
// The route owns the URL state and nothing else: `validateSearch` runs the §9.2.3 schema and
// the screen reads it back typed, so a filtered list is shareable, survives refresh, and Back
// is a filter-undo.
//
// `Operations.Read` is UI-003's guard and stays: the sidebar hides the entry, and this renders
// SCR-SYS-403 for the URL that was typed anyway (§9.2.2). Every write — the registry dialog,
// the „Citire nouă" button — is mirrored against `Operations.Write`, which the `accountant`
// role does not hold.

import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { RequirePermission } from '@/components/layout/route-guards';
import { UtilityList } from '@/features/utilities/UtilityList';
import { utilitySearchSchema, type UtilitySearch } from '@/features/utilities/search';

export const Route = createFileRoute('/app/utilities/')({
  validateSearch: utilitySearchSchema,
  component: UtilitiesScreen,
});

function UtilitiesScreen() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <RequirePermission permission="Operations.Read">
      <UtilityList
        search={search}
        onSearchChange={(next: (previous: UtilitySearch) => UtilitySearch) => {
          void navigate({ search: next });
        }}
      />
    </RequirePermission>
  );
}
